'use strict';

var React = require('react');

const Context = React.createContext(null);
const useSelectContext = () => {
    const value = React.useContext(Context);
    if (!value)
        throw new Error('SelectContext should not be null');
    return value;
};
const SelectProvider = Context.Provider;

exports.SelectProvider = SelectProvider;
exports.useSelectContext = useSelectContext;
//# sourceMappingURL=context.js.map
